import { render, staticRenderFns } from "./pogs-form__item--migs-information.vue?vue&type=template&id=26f9900a&scoped=true&"
import script from "./pogs-form__item--migs-information.vue?vue&type=script&lang=js&"
export * from "./pogs-form__item--migs-information.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form__item--migs-information.vue?vue&type=style&index=0&id=26f9900a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f9900a",
  null
  
)

export default component.exports